export default "__VITE_ASSET__dfoUqKM___"